(function (angular) {
	'use strict';
	angular.module('SMART2').directive('smartTreePopup', ['$timeout',
	function($timeout) {
		return {
			restrict : 'E',
			scope : {
				header : "@",
				isRadio : "@",
				toggle : "@",
				preselection : "@",
				onHide : "&",
				onSelect : "&",
                disableLevelSelection : "@"
			},
			link : function(scope, element, attrs) {
			    //watch treePopupToggle boolean to toggle popup
			    var isInitServiceCall = true;
				scope.$watch('toggle', function(value) {
				    scope.showPopupBool = scope.$eval(value);
				    if (scope.showPopupBool) {
				        scope.treeConfig.hideSearch = false;
				        if (isInitServiceCall) {
				            $timeout(function () {
				                scope.treeConfig.initServiceCall();
				            });
				            isInitServiceCall = false;
				        }
				    }
				});
				
				//watch preselection
				scope.$watch('preselection', function(value) {
					scope.treeConfig.SelectedNodes = value;
				});

				//on-hide callback
				var hideCallback = scope.$eval(scope.onHide);
				
				//on-select callback
				var selectCalback = scope.$eval(scope.onSelect);

				//creating Tree Component Config
				scope.treeConfig = {
					IsRadio : scope.$eval(scope.isRadio),
					type : "Category",
					SelectedNodes : "",
					title: scope.header,
					disableLevelSelection: scope.disableLevelSelection,
                    hideSearch : false
				};
				scope.onDoneCallback = function(e) {
					if (angular.isFunction(selectCalback)) {
						selectCalback(e);
					};
				};

				// view bindings
				scope.showPopupBool = false;
				scope.onPopupHideCallback = function() {
				    scope.showPopupBool = false;
				    scope.treeConfig.hideSearch = true;
					if (angular.isFunction(hideCallback)) {
						hideCallback();
					};
				};
			},
			templateUrl : 'shared/directives/smartTree/smartTreePopup.html'
		};
	}]);

	/*******----smartTreeComponent Module----*******/

	angular.module('smartTreeComponent', []).directive('smartTreeComponent', ['$timeout', '$translate', 'RESTApiSt', '$q', 'APPCONSTANTS', 'Common',
	function ($timeout, $translate, RESTApiSt, $q, APPCONSTANTS, Common) {
		return {
			restrict : 'E',
			replace : true,
			scope : {
				config : '=',
				onDone : '&'
			},
			link: function (scope, element, attrs) {

			    // ID's generation
			    scope.parentId = 'Parent_' + Common.uniqueIDGenerator();
			    scope.templateId = 'Template_' + Common.uniqueIDGenerator() + '.html';


				/*config for the directive*/
			    scope.config.initServiceCall = function () {
			        RESTApiSt.getData(scope.treeConfig.type, RESTApiStCallback, req);
			    }
				scope.treeConfig = scope.config;
				var doneCallback = scope.$eval(scope.onDone);
				scope.$watch('config.SelectedNodes', function(n, o) {
					if (n) {
						preselection = n.split(',');
						if (preselectionRecievedPromise)
							preselectionRecievedPromise.resolve();
					}
				});

				scope.$watch('config.hideSearch', function (n, o) {
				    if (n && scope.searchFieldVal.length > 0) {
				        $timeout(function () {
				            angular.element('#closeButton').trigger('click');
				        });
				    }
				});

				/*promise*/
				var dataRecievedCallPromise;
				var preselectionRecievedPromise;
				var promises = [];
				initializePromise(true, true);

				/*Local variables*/
				var dataSet;
				var searchBucket = 50;
				var lazyLoadingBucket = 50;
				var maxLevel;
				var lazyLoadOffset;
				var lazyLoadMarker = [];
				var levelKey = 'level';
				var levelWiseData = {};
				var parentStringConstant = "parentString";
				var parentCodeStringConstant = "parentCodeString";
				var preselection;
				var searchCategories = [];
				var req;

				switch(scope.treeConfig.type) {
				case 'Category':
					scope.codeProperty = 'PASCode';
					scope.titleProperty = 'PASName';
					scope.levelProperty = 'PASLevel';
					scope.parentProperty = 'ParentPASCode';
					/*req = {
					    method: 'POST',
					    url: 'https://gepqcsmart-rest.servicebus.windows.net/PortalRestService/GetPASForDeviceMob',
					    headers: {
					        'Content-Type': 'application/json',
					        'UserExecutionContext': '{"ClientName":"BuyerSqlConn","ClientID":2,"BuyerPartnerCode":6315,"Product":2,"UserId":"28082","EntityType":"supplier registration","EntityId":8888,"LoggerCode":"EC101","Culture":"en-US","UserName":"RiteAid.Admin@gep.com","CompanyName":"BuyerSqlConn","ContactCode":63150040000001}'
					    },
					    data: {
					        "ContactCode": 63150040000001,
					        "entityDetailCode": 7,
					        "entityId": 1
					    }
					};*/
					req = {
					    method: 'POST',
					    url: APPCONSTANTS.userPreferences.URLs.AppURL + 'PortalRestService/GetPASForDeviceMob?oloc=218',
					    headers: {
					        'Content-Type': 'application/json',
					        'UserExecutionContext': JSON.stringify(APPCONSTANTS.userPreferences.UserBasicDetails),
					    },
					    data: {
					        "ContactCode": APPCONSTANTS.userPreferences.UserBasicDetails.ContactCode,
					        "entityDetailCode": APPCONSTANTS.userPreferences.ACEntityId,
					        "entityId": APPCONSTANTS.userPreferences.UserBasicDetails.EntityId
					    }
					};
					break;
				case 'Region':
					scope.codeProperty = 'RegionId';
					scope.titleProperty = 'RegionName';
					scope.levelProperty = 'RegionLevel';
					scope.parentProperty = 'RegionParentId';
					break;
				};
				
				scope.isLoading = true;
				scope.selectedData = [];
				scope.isSingleSelect = scope.treeConfig.IsRadio;
				scope.msg = $translate.instant('loadingMsg');

				/*Local member fuctions*/

				function initializePromise(dataRievedPromiseBool, preselectionRecievedPromiseBool) {
					dataRecievedCallPromise = null;
					preselectionRecievedPromise = null;
					promises.length = 0;
					if (dataRievedPromiseBool) {
						dataRecievedCallPromise = $q.defer();
						promises.push(dataRecievedCallPromise.promise);
					}
					if (preselectionRecievedPromiseBool) {
						preselectionRecievedPromise = $q.defer();
						promises.push(preselectionRecievedPromise.promise);
					}
					$q.all(promises).then(promiseResolved);
				}

				function promiseResolved() {
					initatePreSelection();
					initializePromise(false, true);
				}

				function createLevelWiseDataSet() {
					var level = 1;
					var parentNodes = dataSet[level];
					insertParentHierarchyForFlatStrucure(parentNodes);
					while (parentNodes) {
						levelWiseData[levelKey + level] = parentNodes;
						insertParentHierarchyForFlatStrucure(parentNodes, level);
						maxLevel = level;
						level = level + 1;
						parentNodes = dataSet[level];
					}
				};

				function insertParentHierarchyForFlatStrucure(parentNodes, level) {
					var fetchedData = (level) ? _.groupBy(dataSet[level + 1], scope.parentProperty) : null;
					_.each(parentNodes, function(parent) {
						var childForParent = (fetchedData) ? fetchedData[parent[scope.codeProperty]] : parentNodes;
						if (childForParent) {
							_.each(childForParent, function(node, index) {
								node[parentStringConstant] = parent[parentStringConstant] ? parent[parentStringConstant] + ' > ' + node[scope.titleProperty] : (node[scope.levelProperty] > 1) ? parent[scope.titleProperty] + ' > ' + node[scope.titleProperty] : "";
								node[parentCodeStringConstant] = parent[parentCodeStringConstant] ? parent[parentCodeStringConstant] + '>' + node[scope.codeProperty] : (node[scope.levelProperty] > 1) ? parent[scope.codeProperty] + '>' + node[scope.codeProperty] : "";
								node['isExpanded'] = false;
								node['selection'] = "0";
								node['index'] = index;
							});
						}
					});
				};

				function RESTApiStCallback(response) {
				    try{
				        dataSet = _.groupBy(JSON.parse(response.data.GetPASForDeviceMobResult), scope.levelProperty);
				        createLevelWiseDataSet();
				        scope.categories = levelWiseData[levelKey + '1'].slice(0, lazyLoadingBucket);
				        lazyLoadMarker.push(levelWiseData[levelKey+'1'][levelWiseData[levelKey + '1'].length - 1]);
				        scope.isLoading = false;
				    }catch(e){
				        scope.msg = $translate.instant('loadingDataErr');
				    }
				    dataRecievedCallPromise.resolve();
				};

				function resetSelectionState() {
					_.each(scope.selectedData, function(_node) {
						scope.selectNode(_node, '0');
					});
				};

				function initatePreSelection() {
					resetSelectionState();
					_.each(preselection, function(preselectionNode) {
						var searchLevel = 1;
						while (searchLevel <= maxLevel) {
							var foundNode = _.groupBy(levelWiseData[levelKey + searchLevel],scope.codeProperty)[preselectionNode];
							if (foundNode) {
								scope.selectNode(foundNode[0], '1');
								break;
							}
							searchLevel = searchLevel + 1;
						}
					});
				};

				function openSelectionTree() {
					var partialSeletedNodes = _.filter(levelWiseData[levelKey + 0], function(node) {
						return node.selection = '2';
					});
					_.each(partialSeletedNodes, function(nodes) {
						var level = nodes[scope.levelProperty];
						//var childs = _.
					});
				}

				function getChildsForParentAsPerBucket(parent, bucket, startIndex) {
					var childSearchLevel = parent[scope.levelProperty] + 1;
					var parentCodeStringIterator;
					var result = _.groupBy(levelWiseData[levelKey+childSearchLevel],scope.parentProperty)[parent[scope.codeProperty]];
					//var bucketData = (bucket) ? result.slice(startIndex, startIndex + bucket) : result;
					var bucketData = result;
					return bucketData;
				};

				function lazyLoadLevelWiseData(markerNode) {
					var parentSearchLevel = markerNode[scope.levelProperty] - 1;
					var markerNodeParent = markerNode[scope.parentProperty];
					var parent = _.find(levelWiseData[levelKey + parentSearchLevel], function(node) {
						return node[scope.codeProperty] == markerNodeParent;
					});
					if (parent) {
						var bucketChilds = getChildsForParentAsPerBucket(parent, lazyLoadingBucket, markerNode.index + 1);
						console.log('childs appended = ' + bucketChilds.length);
						if (bucketChilds.length > 0) {
							parent.children = parent.children.concat(bucketChilds);
							lazyLoadMarker.push(bucketChilds[bucketChilds.length - 1]);
							scope.$apply();
						}
					}
				};

				var searchString = "";
				var searchLevel;
				var searchDataYetToBeDisplayed = [];
				var searchWithContainsHitResult = [];
				scope.searchResults = [];
				function searchAsPerBucketSize(searchStr, bucket) {
					if (searchString != searchStr) {
						searchString = searchStr;
						searchLevel = maxLevel;
						searchDataYetToBeDisplayed.length = 0;
						searchWithContainsHitResult.length = 0;
						scope.searchResults.length = 0;
					};
					var searchData = getDataAsPerBucketSize(searchStr, bucket);
					scope.searchResults = scope.searchResults.concat(searchData);
				};

				function getOffsetSearchData(bucket) {
					var partitionedData = _.partition(searchDataYetToBeDisplayed, function(data, index) {
						return index > (bucket - 1);
					});
					searchDataYetToBeDisplayed = partitionedData[0];
					return partitionedData[1];
				};

				function getOffsetSearchDataForContainsSearch(bucket) {
					var partitionedData = _.partition(searchWithContainsHitResult, function(data, index) {
						return index > (bucket - 1);
					});
					searchWithContainsHitResult = partitionedData[0];
					return partitionedData[1];
				};

				function getDataAsPerBucketSize(searchStr, bucket) {
					var bucketData = [];
					while (bucketData.length < bucket && searchLevel > 0) {
						var offsetSearchData = getOffsetSearchData(bucket);
						if (offsetSearchData.length == bucket) {
							bucketData = offsetSearchData;
							break;
						}
						var searchData = _.filter(levelWiseData[levelKey + searchLevel], function(node) {
							return -1 != node[scope.titleProperty].toLowerCase().indexOf(searchString.toLowerCase());
						});

						var containsSarchResult = _.filter(levelWiseData[levelKey + searchLevel], function(node) {
							return new RegExp("(" + _.compact(searchString.split(' ')).join('|') + ")", "gi").test(node[scope.titleProperty]) && -1 == node[scope.titleProperty].toLowerCase().indexOf(searchString.toLowerCase());
						});
						searchWithContainsHitResult = searchWithContainsHitResult.concat(containsSarchResult);
						var qumulativeData = offsetSearchData.concat(searchData);
						var partitionedData = _.partition(qumulativeData, function(data, index) {
							return index > (bucket - 1);
						});
						searchDataYetToBeDisplayed = searchDataYetToBeDisplayed.concat(partitionedData[0]);
						bucketData = bucketData.concat(partitionedData[1]);
						searchLevel = searchLevel - 1;
					}
					if (searchLevel == 0) {
						while (bucketData.length < bucket) {
							var containsSearchDataToBeAppended = getOffsetSearchDataForContainsSearch(bucket);
							if (containsSearchDataToBeAppended.length > 0) {
								bucketData = bucketData.concat(containsSearchDataToBeAppended);
							} else {
								break;
							}
						}
					}
					return bucketData;
				};

				function closeChildsForParent(parent) {
					var childs = _.filter(getChildsForParentAsPerBucket(parent), function(childNode) {
						return childNode.isExpanded;
					});
					_.each(childs, function(child) {
						child.isExpanded = false;
						child.children = [];
						closeChildsForParent(child);
					});
				}


				scope.searchText = '';
				scope.searchFieldVal = '';

				scope.expandNode = function(node, index) {
					node.isExpanded = !node.isExpanded;
					if (node.isExpanded) {
						node.children = getChildsForParentAsPerBucket(node, lazyLoadingBucket, 0);
						lazyLoadMarker.push(node.children[node.children.length - 1]);
					} else {
						node.children = [];
						removeMarkerForParent(node);
					}
				};

				function removeMarkerForParent(parent) {
					var childMarkers = _.filter(lazyLoadMarker, function(node, index) {
						return -1 != node[parentCodeStringConstant].indexOf(parent[scope.codeProperty]);
					});
					lazyLoadMarker = _.difference(lazyLoadMarker, childMarkers);
					closeChildsForParent(parent);
				};

				var filterTextTimeout;
				scope.searchAndSelectNode = function(node) {
					if (filterTextTimeout)
						$timeout.cancel(filterTextTimeout);
					filterTextTimeout = $timeout(function() {
						if (scope.searchFieldVal.length > 2)
							searchAsPerBucketSize(scope.searchFieldVal, searchBucket);
						else {
							searchDataYetToBeDisplayed.length = 0;
							searchWithContainsHitResult.length = 0;
						}
					}, 300);
				};

				scope.selectNode = function(node, selectionState) {
					node.selection = selectionState;
					if (scope.isSingleSelect) {
					    if (scope.selectedData && scope.selectedData[0] && scope.selectedData[0][scope.codeProperty] != node[scope.codeProperty]) {
					        scope.selectedData[0].selection = '0';
					    };
					    scope.selectedData = (selectionState == '0') ? [] : [node];
					} else {
						updateSelectionObject(node, selectionState);
						updateChildsForNode(node, selectionState);
					}
					updateParentForNode(node, selectionState);
				};

				function updateSelectionObject(node, selectionState) {
					switch(selectionState) {
					case '0':
						scope.selectedData = _.without(scope.selectedData, node);
						break;
					case '1':
						scope.selectedData.push(node);
						break;
					}
				};

				function updateParentForNode(node, selectionState) {
					var depthLevel = node[scope.levelProperty] - 1;
					var immediateParentCode = node[scope.parentProperty].toString();
					while (depthLevel > 0) {
						var parent = _.find(levelWiseData[levelKey + depthLevel], function(node) {
							return node[scope.codeProperty] == immediateParentCode;
						});
						immediateParentCode = parent[scope.parentProperty].toString();
						if (!parent['isExpanded']) {
							scope.expandNode(parent);
						}
						if (!scope.isSingleSelect) {
							parent.selection = getStateForNode(parent);
						}
						depthLevel = depthLevel - 1;
					}
				};

				function getStateForNode(node) {
					var childCount = node.ChildCount;
					var depthLevel = node[scope.levelProperty] + 1;
					var parentCode = node[scope.codeProperty];
					var groupByData = _.groupBy(levelWiseData[levelKey + depthLevel], scope.parentProperty);
					var selectedChild = _.filter(groupByData[parentCode], function(node) {
						return node.selection == '1';
					});
					var partiallySelectedChild = _.filter(groupByData[parentCode], function(node) {
						return node.selection == '2';
					});
					if (childCount == selectedChild.length) {
						scope.selectedData = _.difference(scope.selectedData, selectedChild);
						scope.selectedData.push(node);
						return "1";
					} else if ((selectedChild.length + partiallySelectedChild.length) > 0) {
						scope.selectedData = _.union(scope.selectedData, selectedChild);
						scope.selectedData = _.without(scope.selectedData, node);
						return "2";
					} else {
						scope.selectedData = _.union(scope.selectedData, selectedChild);
						scope.selectedData = _.without(scope.selectedData, node);
						return "0";
					}
				};

				function updateChildsForNode(node, selectionState) {
					var depthLevel = node[scope.levelProperty] + 1;
					var parentCode = node[scope.codeProperty].toString();
					while (depthLevel <= maxLevel) {
						var childs = _.filter(levelWiseData[levelKey + depthLevel], function(node) {
							return -1 != node[parentCodeStringConstant].indexOf(parentCode);
						});
						_.each(childs, function(child) {
							child.selection = selectionState;
							if (selectionState == "1") {
								scope.selectedData = _.without(scope.selectedData, child);
							};
						});
						depthLevel = depthLevel + 1;
					}
				}

				var uniqueIDGenerator = function() {
					var d = new Date().getTime();
					var uniqueID = 'xxx2xxxpxxxoxxx'.replace(/[xy]/g, function(c) {
						var r = (d + Math.random() * 16) % 16 | 0;
						d = Math.floor(d / 16);
						return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
					});
					return uniqueID;
				};
				if (scope.isSingleSelect) {
					scope.uniqueRadioGroupName = uniqueIDGenerator();
				}

				/*$timeout(function() {
					lazyLoadOffset = angular.element("#treeComponentContainer")[0].getBoundingClientRect().bottom;
					angular.element('.scrollbar-outer').scrollbar({
						onScroll : function(y, x) {
							if (lazyLoadMarker.length > 0 && scope.searchFieldVal.length == 0) {
								var markerNode = lazyLoadMarker[lazyLoadMarker.length - 1];
								if (angular.element("#"+markerNode[scope.codeProperty])[0].getBoundingClientRect().top <= lazyLoadOffset) {
									console.log(markerNode);
									lazyLoadMarker.length = (lazyLoadMarker.length > 0) ? lazyLoadMarker.length - 1 : 0;
									lazyLoadLevelWiseData(markerNode);
									console.log(lazyLoadMarker.length);
								}
							}
							if (y.maxScroll > 0 && y.scroll == y.maxScroll && scope.searchFieldVal.length > 0) {
								$timeout(function() {
									searchAsPerBucketSize(scope.searchFieldVal, searchBucket);
								});
							}
						}
					});
				});*/
				
				scope.scrollEnd = function(e){
					searchAsPerBucketSize(scope.searchFieldVal, searchBucket);
				};

				scope.doneButton = { title: $translate.instant("doneBtn") };

				scope.doneClickHandler = function() {
					if (angular.isFunction(doneCallback)) {
						doneCallback(scope.selectedData);
					}
				};
				
				scope.focusSearch = false;
				scope.isActive = false;
				scope.showMe = false;
				scope.showSearch = function () {
				    scope.isActive = true;
				    scope.focusSearch = true;
				    scope.showMe = true;
				    scope.hideClose = true;
				}

				scope.hideSearch = function () {
				    scope.isActive = false;
				    scope.focusSearch = false;
				    scope.hideClose = false;


				}


			},
			templateUrl : 'shared/directives/smartTree/smartTreeTemplate.html'
		};
	}]).directive('ngIndeterminate', function($compile) {
		return {
			restrict : 'A',
			link : function(scope, element, attributes) {
				scope.$watch(attributes['ngIndeterminate'], function(value) {
					element.prop('indeterminate', value);
				});
			}
		};
	}).directive('ngHighlightSt',['$compile', 'hilitor', function($compile, hilitor) {
		return {
			restrict : 'A',
			link : function(scope, element, attributes) {
				scope.$watch(attributes['ngHighlight'], function(value) {
					hilitor.getHilitor().apply(value);
				});
			}
		};
	}]).service('RESTApiSt', ['$http',
	function($http) {
		var Callback;

		this.getData = function(mode, callback, requestObject) {
			switch(mode) {
			case 'Category':
				Callback = callback;
				serviceCall(requestObject);
				break;
			}
		};

		function serviceCall(req) {
			$http(req).then(function(response) {
				Callback(response);
			}, function(error) {
				Callback(error);
			});
		};
	}]).service('hilitor', [
	function() {
		var hilitor = new Hilitor("treeComponentContainer");
		this.getHilitor = function() {
			return hilitor;
		};
	}]);

})(angular);
